import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAAurl, setIframeUrl } from "../../../../store/app/aaSlice";
import { setOffers } from "../../../../store/app/appReducer";
import callApi from "../../../../utility/apiCaller";
import useAddLead from "../../hooks/addLeadtoCRM";
import { setUserClickData } from "../../../../utility/setUserClickData";
import useUserEvent from "../../../../hooks/setUserclickhook";
import StickyCtaBar from "../../UIElements/StickyCtaBar";
import { useSearchParams } from "react-router-dom";

const DMI_ID = "68ad8ed5078abf6c677e4303";
const DMI = "DMI";
const FATAKPAY_ID = "6851271c3a9753dd00d85475";
const HERO_ID = "67ef646df80610d286084e60";
// Lenders whose app url opens inside an iframe
const ZYPE_ID = "662752eb65fdba1a48d6e47a";
const CREDFIN_ID = "6a6ed6aefe1e854b8cbdf86a";

const IFRAME_LENDER_IDS = [ZYPE_ID, CREDFIN_ID].filter(Boolean);
const IFRAME_LENDER_NAMES = ["Zype", "CredFin"];

const CHECKLIST = [
  "Keep your PAN & Aadhaar handy.",
  "It will take less than 2-3 minutes to complete the process.",
  "We'll track your application and notify you if any additional action is required.",
];

// Sits between "I like this" and the actual lender hand-off. The
// lender-specific routing below (DMI/AA, FatakPay, generic
// app_url redirect) is exactly what offerCard2.js's button used to do the
// instant you clicked it -- now it only fires once the user has actually
// confirmed on this screen.
const CompleteApplication = ({ selectedOffer, setCurrentStep }) => {
  const offer = selectedOffer || {};
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const addLead = useAddLead();
  const { trackUserEvent } = useUserEvent();
  const aaSlice = useSelector((state) => state?.aa);
  const leadId = aaSlice?.internalLeadId;

  const [loadingStep, setLoadingStep] = useState(false);

  const isDMIOffer = offer?.lender_name === DMI || offer?.lender_id === DMI_ID;
  const isFatkPayOffer = offer?.lender_id === FATAKPAY_ID;
  const aaReq = offer?.aa_required;

  const lenderName = String(offer?.lender_name || "").trim();
  const isIframeLenderOffer =
    Boolean(offer?.app_url) &&
    (IFRAME_LENDER_IDS.includes(offer?.lender_id) ||
      IFRAME_LENDER_NAMES.includes(lenderName));

  const callAPIandRedirect = async () => {
    if (!leadId) return;
    try {
      setLoadingStep(true);
      const res = await callApi("v1/lead/list", "post", { filters: { _id: leadId } }, "core");
      if (res.status === "Success" && res.data?.leadList.length > 0) {
        const { dmi_offers_details } = res.data.leadList[0];
        dispatch(setOffers(dmi_offers_details));
        setCurrentStep(7); // LoanPreApproval (was prev+1, which broke from the "complete_application" string step)
      } else {
        throw new Error("Error while fetching data");
      }
    } catch (error) {
      console.error("Error calling API:", error);
    } finally {
      setLoadingStep(false);
    }
  };

  const handleContinue = () => {
    trackUserEvent(`offer-apply-button-for-multistep-pl-v1-${offer.lender_name}`, offer.lead_id);
    trackUserEvent(`offer-apply-button-for-multistep-pl-v1-${offer.lender_name}`, offer.lead_id);

    setUserClickData({
      event_name: `complete-application-multistep-pl-v1-${offer?.lender_name || "unknown"}`,
      user_id: offer?.contact_phone || offer?.lead_id || "unknown",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
      utm_source: params.get("utm_source") || params.get("utm_medium"),
      utm_term: params.get("utm_term"),
    });

    if (leadId) {
      // Mark on the lead that the user clicked "Continue Application" on an offer.
      callApi(
        `v1/lead/${leadId}/update-lead-new`,
        "post",
        { lead: { offers_clicked: ["true"] } },
        "core"
      ).catch((err) => console.error("Failed to update offers_clicked:", err));
      try {
        addLead({
          leadId,
          lead_type: "live",
          priority: 2,
          stage: `Offer Clicked for ${offer.lender_name}`,
        }).catch((error) => console.error("Error adding lead to CRM:", error));
      } catch (error) {
        console.error("Error adding lead to CRM:", error);
      }
    }

    if (isDMIOffer && aaReq) {
      dispatch(setAAurl(offer.app_url));
      setCurrentStep(4);
    } else if (isDMIOffer && !aaReq) {
      callAPIandRedirect();
    } else if (isFatkPayOffer || isIframeLenderOffer) {
      dispatch(setIframeUrl(offer.app_url));
      setCurrentStep(61);
    } else {
      window.location.href = `${offer.app_url}`;
    }
  };

  return (
    <>
      <div className="w-full max-w-[400px] mx-auto bg-white px-4 pb-[120px] flex flex-col font-atkinson">
        <button
          type="button"
          onClick={() => setCurrentStep(6)}
          aria-label="Go back"
          className="w-6 h-6 flex-none flex items-center justify-center mt-2"
        >
          <img src={process.env.PUBLIC_URL + "/assets/icons/left_arrow.png"} alt="" className="w-5 h-5 object-contain" />
        </button>

        <h1 className="text-[18px] font-bold text-[#1b1b1b] mt-4">Let's Complete your Application</h1>
        <p className="text-[13px] text-[#8b8b8b] mt-2">
          You've selected Lender {offer?.lender_name || "your chosen lender"}.
        </p>
<br/>
        <p className="text-[16px] font-bold text-[#1b1b1b] mt-8 leading-[1.3]">
          To complete your application, you will now be redirected to the lender's app:
        </p>

        <div className="bg-[#f6f6f6] rounded-[20px] px-3 mt-9">
          {CHECKLIST.map((item, i) => (
            <div
              key={item}
              className={"flex items-start gap-3 py-3 " + (i > 0 ? "border-t border-[#e5e5e5]" : "")}
            >
              <span className="w-[22px] h-[22px] rounded-full bg-black flex items-center justify-center flex-none mt-[1px]">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12l5 5L20 6" />
                </svg>
              </span>
              <span className="text-[14px] text-[#1b1b1b] leading-[1.35]">{item}</span>
            </div>
          ))}
        </div>
      </div>

      <StickyCtaBar>
        <button
          type="button"
          onClick={handleContinue}
          id="offer-selected-v17"
          disabled={loadingStep}
          className="w-full bg-black text-white font-bold text-[16px] rounded-[16px] py-[17px] active:scale-[0.99] transition-transform disabled:opacity-50"
        >
          Continue Application
        </button>
      </StickyCtaBar>
    </>
  );
};

export default CompleteApplication;